export default __webpack_public_path__ + "static/2-8c79d47d364479e598a86430da386494.jpeg";